import React from 'react'
import { useTranslation } from 'react-i18next'

import { WellnessAccordion } from 'components/WellnessAccordion'

import { StyledBeforeYouBuy as S } from './BeforeYouBuy.styles'
import { BEFORE_YOU_BUY_QUESTIONS } from './constants'

export const BeforeYouBuy: React.FC = () => {
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Title>{t('onboarding.landingWellness.beforeYouBuy.title')}</S.Title>

      <S.List>
        {BEFORE_YOU_BUY_QUESTIONS.map(({ questionKey, answerKey }) => (
          <WellnessAccordion key={questionKey} titleKey={questionKey}>
            <S.Answer>{t(answerKey)}</S.Answer>
          </WellnessAccordion>
        ))}
      </S.List>
    </S.Wrapper>
  )
}
